/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import {
  Modal,
  Form,
} from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { Scrollbars } from 'react-custom-scrollbars-2';
import api from '../../api';
import ClarLoader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import JiraLogo from '../../images/icons/jira/jira_origin.svg';
import JiraHighest from '../../images/icons/jira/highest.svg';
import JiraHigh from '../../images/icons/jira/high.svg';
import JiraMedium from '../../images/icons/jira/medium.svg';
import JiraLow from '../../images/icons/jira/low.svg';
import JiraLowest from '../../images/icons/jira/lowest.svg';
import JiraAvata from '../../images/icons/jira/default-avatar.png';
import './CreateJiraIssueModal.css';

class CreateJiraIssueModal extends Component {
  constructor(props) {
    super(props);
    this.modalAction = null;
    this.modalBody = null;
    this.state = {
      isOpenMCI: props.isOpenMCI,
      isOpenJiraModal: false,
      isModalLoading: false,
      isLoading: false,
      isGlobalErrorLoading: false,
      isModalErrorLoading: false,
      isSetLoading: false,
      isBoxLoading: false,
      isOpenAlertModal: false,
      projectList: [],
      componentList: [],
      issueTypeList: [],
      priorityList: [],
      labelList: [],
      assigneeList: [],
      selectedProject: '',
      selectedIssueType: '',
      selectedAssignee: '',
      selectedComponents: [],
      selectedLabels: [],
      selectedPriority: '',
      isErrorProject: false,
      isErrorIssueType: false,
      isErrorAssignee: false,
      isErrorComponents: false,
      isErrorLabels: false,
      isErrorPriority: false,
      issueStatus: 0,
      errorMsg: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleAssigneeChange = this.handleAssigneeChange.bind(this);
    this.handleLabelChange = this.handleLabelChange.bind(this);
    this.handlePriorityChange = this.handlePriorityChange.bind(this);
    this.handleComponentChange = this.handleComponentChange.bind(this);
    this.handleSelectChange = this.handleSelectChange.bind(this);
    this.handleIssueSelectChange = this.handleIssueSelectChange.bind(this);
    this.setJiraIssueWithPolicy = this.setJiraIssueWithPolicy.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeJIraModal = this.closeJIraModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { isOpenMCI, selectedPolicyId } = this.props;

    if (prevProps.isOpenMCI !== isOpenMCI) {
      this.setState({
        isOpenMCI,
        isOpenJiraModal: false,
        isModalLoading: false,
        isLoading: false,
        isGlobalErrorLoading: false,
        isModalErrorLoading: false,
        isSetLoading: false,
        isBoxLoading: false,
        isOpenAlertModal: false,
        isErrorProject: false,
        isErrorIssueType: false,
        isErrorAssignee: false,
        isErrorComponents: false,
        isErrorLabels: false,
        isErrorPriority: false,
        projectList: [],
        componentList: [],
        issueTypeList: [],
        priorityList: [],
        labelList: [],
        assigneeList: [],
        selectedProject: '',
        selectedIssueType: '',
        selectedAssignee: '',
        selectedComponents: [],
        selectedLabels: [],
        selectedPriority: '',
        errorMsg: '',
        issueStatus: 0,
      });
      if (isOpenMCI) {
        this.getJiraIssueWithPolicy(selectedPolicyId);
      }
    }
  }

  handleSelectChange = (e, { value }) => {
    this.setState({
      selectedProject: value,
      isErrorProject: false,
      isErrorIssueType: false,
      selectedIssueType: '',
      issueTypeList: [],
    });
  };

  handleIssueSelectChange = (e, { value }) => {
    this.setState({
      selectedIssueType: value,
      isErrorIssueType: false,
    });
  };

  handleComponentChange = (e, { value }) => {
    this.setState({
      selectedComponents: value,
      isErrorComponents: false,
    });
  };

  handlePriorityChange = (e, { value }) => {
    this.setState({
      selectedPriority: value,
      isErrorPriority: false,
    });
  };

  handleLabelChange = (e, { value }) => {
    this.setState({
      selectedLabels: value,
      isErrorLabels: false,
    });
  };

  handleAssigneeChange = (e, { value }) => {
    this.setState({
      selectedAssignee: value,
      isErrorAssignee: false,
    });
  };

  onSubmit() {
    const { translate } = this.props;

    if (!this.issueValidation()) {
      return;
    }

    this.modalAction = translate('modal.title.attention');
    this.modalBody = translate('settings.message.save_issue_policy_jira');

    this.setState({
      isOpenJiraModal: true,
    });

  }

  getJiraIssueWithPolicy(policyId) {
    const { translate } = this.props;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getJiraIssueWithPolicy(policyId)
        .then((res) => {
          const data = res.response;
          let currentProjectList;
          let currentIssueTypeList;
          let currentComponentList;
          let currentPriorityList;
          let currentLabelList;
          let currentAssigneeList;
          let currentSelectedComponentList;

          if (Object.keys(data.project).length > 0) {
            currentProjectList = [
              {
                key: data.project.key,
                text: data.project.name,
                value: data.project.id,
              }
            ];
          } else {
            currentProjectList = [];
          }

          if (Object.keys(data.issue_type).length > 0) {
            currentIssueTypeList = [
              {
                key: data.issue_type.id,
                text: data.issue_type.name,
                value: data.issue_type.id,
              }
            ];
          } else {
            currentIssueTypeList = [];
          }

          if (data.components.length > 0) {
            currentComponentList = data.components.map((item) => {
              return {
                key: item.id,
                text: item.name,
                value: item.id,
              };
            });
            currentSelectedComponentList = data.components.map((item) => {
              return item.id;
            });
          } else {
            currentComponentList = [];
            currentSelectedComponentList = [];
          }

          if (Object.keys(data.priority).length > 0) {
            if (data.priority.id === '1') {
              currentPriorityList = [{
                key: data.priority.id,
                text: data.priority.name,
                value: data.priority.id,
                image: { avatar: true, src: JiraHighest }
              }];
            } else if (data.priority.id === '2') {
              currentPriorityList = [{
                key: data.priority.id,
                text: data.priority.name,
                value: data.priority.id,
                image: { avatar: true, src: JiraHigh }
              }];
            } else if (data.priority.id === '3') {
              currentPriorityList = [{
                key: data.priority.id,
                text: data.priority.name,
                value: data.priority.id,
                image: { avatar: true, src: JiraMedium }
              }];
            } else if (data.priority.id === '4') {
              currentPriorityList = [{
                key: data.priority.id,
                text: data.priority.name,
                value: data.priority.id,
                image: { avatar: true, src: JiraLow }
              }];
            } else if (data.priority.id === '5') {
              currentPriorityList = [{
                key: data.priority.id,
                text: data.priority.name,
                value: data.priority.id,
                image: { avatar: true, src: JiraLowest }
              }];
            }
          } else {
            currentPriorityList = [];
          }

          if (data.labels.length > 0) {
            currentLabelList = data.labels.map((item) => {
              return {
                key: item,
                text: item,
                value: item,
              };
            });
          } else {
            currentLabelList = [];
          }

          if (Object.keys(data.assignee).length > 0) {
            currentAssigneeList = [
              {
                text: data.assignee.display_name,
                value: data.assignee.account_id,
                locale: data.assignee.locale,
                email: data.assignee.email,
                image: { avatar: true, src: JiraAvata }
              }
            ];
          } else {
            currentAssigneeList = [];
          }

          this.setState({
            selectedAssignee: Object.keys(data.assignee).length > 0 ? data.assignee.account_id : '',
            selectedComponents: currentSelectedComponentList,
            selectedIssueType: Object.keys(data.issue_type).length > 0 ? data.issue_type.id : '',
            selectedLabels: data.labels,
            selectedPriority: Object.keys(data.priority).length > 0 ? data.priority.id : '',
            selectedProject: Object.keys(data.project).length > 0 ? data.project.id : '',
            projectList: currentProjectList,
            issueTypeList: currentIssueTypeList,
            componentList: currentComponentList,
            priorityList: currentPriorityList,
            labelList: currentLabelList,
            assigneeList: currentAssigneeList,
            isLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = translate('modal.title.attention');

          const errorCode = o?.error;

          if (errorCode === '422-366') {
            this.modalBody = o.error_description;
          } else if (errorCode === '422-368') {
            this.modalBody = translate('modal.error.error_422_368_jira');
          } else if (errorCode === '422-781') {
            this.modalBody = translate('modal.error.error_422_781_jira');
          } else {
            this.modalBody = translate('modal.error.unknow_error');
          }

          this.setState({
            isLoading: false,
            isOpenJiraModal: true,
            isModalErrorLoading: true,
          });
        });
    });
  }

  getJiraIssueType = () => {
    const {
      isSetLoading, selectedProject,
    } = this.state;

    const obj = {
      project_id: selectedProject,
    };

    if (isSetLoading) {
      api
        .getJiraIssueType(obj)
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item.id,
              text: item.name,
              value: item.id,
            };
          });
          this.setState({
            issueTypeList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.setState({
            isGlobalErrorLoading: true,
            isErrorIssueType: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  };

  getJiraProjectList() {
    const {
      isSetLoading,
    } = this.state;

    if (isSetLoading) {
      api
        .getJiraProjectList()
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item.key,
              text: item.name,
              value: item.id,
            };
          });
          this.setState({
            projectList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;

          this.setState({
            isGlobalErrorLoading: true,
            isErrorProject: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  }

  getJiraComponents() {
    const {
      isSetLoading, selectedProject,
    } = this.state;

    const obj = {
      project_id: selectedProject,
    };

    if (isSetLoading) {
      api
        .getJiraComponents(obj)
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item.id,
              text: item.name,
              value: item.id,
            };
          });
          this.setState({
            componentList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.setState({
            isGlobalErrorLoading: true,
            isErrorComponents: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  }

  getJiraPriority() {
    const {
      isSetLoading,
    } = this.state;

    if (isSetLoading) {
      api
        .getJiraPriority()
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            if (item.id === '1') {
              return {
                key: item.id,
                text: item.name,
                value: item.id,
                image: { avatar: true, src: JiraHighest }
              };
            }
            if (item.id === '2') {
              return {
                key: item.id,
                text: item.name,
                value: item.id,
                image: { avatar: true, src: JiraHigh }
              };
            }
            if (item.id === '3') {
              return {
                key: item.id,
                text: item.name,
                value: item.id,
                image: { avatar: true, src: JiraMedium }
              };
            }
            if (item.id === '4') {
              return {
                key: item.id,
                text: item.name,
                value: item.id,
                image: { avatar: true, src: JiraLow }
              };
            }
            return {
              key: item.id,
              text: item.name,
              value: item.id,
              image: { avatar: true, src: JiraLowest }
            };
          });
          this.setState({
            priorityList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.setState({
            isGlobalErrorLoading: true,
            isErrorPriority: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  }

  getJiraLabel() {
    const {
      isSetLoading,
    } = this.state;

    if (isSetLoading) {
      api
        .getJiraLabel()
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item,
              text: item,
              value: item,
            };
          });
          this.setState({
            labelList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.setState({
            isGlobalErrorLoading: true,
            isErrorLabels: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  }

  getJiraAssignee() {
    const {
      isSetLoading, selectedProject, projectList
    } = this.state;

    const project = projectList.filter((item) => {
      return item.value === selectedProject;
    });

    const obj = {
      project_key: project[0].key,
    };

    if (isSetLoading) {
      api
        .getJiraAssignee(obj)
        .then((res) => {
          const data = res.response;
          const newData = data.map((item) => {
            return {
              key: item.account_id,
              text: item.display_name,
              value: item.account_id,
              locale: item.locale,
              email: item.email,
              image: { avatar: true, src: JiraAvata }
            };
          });
          this.setState({
            assigneeList: newData,
            isSetLoading: false,
            isBoxLoading: false,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.setState({
            isGlobalErrorLoading: true,
            isErrorAssignee: true,
            isSetLoading: false,
            isBoxLoading: false,
            errorMsg: o.error_description,
          });
        });
    }
  }

  setJiraIssueWithPolicy() {
    const { selectedPolicyId, translate } = this.props;
    const {
      projectList,
      issueTypeList,
      componentList,
      priorityList,
      labelList,
      assigneeList,
      selectedProject,
      selectedIssueType,
      selectedComponents,
      selectedPriority,
      selectedLabels,
      selectedAssignee,
    } = this.state;

    let objWithProject;
    let objWithIssueType;
    let objWithComponents;
    let objWithPriority;
    let objWithLabel;
    let objWithAssignee;

    const project = projectList.filter((item) => {
      return item.value === selectedProject;
    });

    const issueType = issueTypeList.filter((item) => {
      return item.value === selectedIssueType;
    });

    const component = componentList.filter((item) => {
      return selectedComponents.indexOf(item.value) > -1;
    });

    const priority = priorityList.filter((item) => {
      return item.value === selectedPriority;
    });

    const labels = labelList.filter((item) => {
      return selectedLabels.indexOf(item.value) > -1;
    });

    const assignee = assigneeList.filter((item) => {
      return item.value === selectedAssignee;
    });

    if (project.length !== 0) {
      objWithProject = {
        id: project[0].value,
        name: project[0].text,
        key: project[0].key
      };
    } else {
      objWithProject = {};
    }

    if (issueType.length !== 0) {
      objWithIssueType = {
        id: issueType[0].value,
        name: issueType[0].text,
      };
    } else {
      objWithIssueType = {};
    }

    if (component.length !== 0) {
      const select = component.map((item) => {
        return {
          id: item.value,
          name: item.text,
        };
      });
      objWithComponents = select;
    } else {
      objWithComponents = [];
    }

    if (priority.length !== 0) {
      objWithPriority = {
        id: priority[0].value,
        name: priority[0].text,
      };
    } else {
      objWithPriority = {};
    }

    if (labels.length !== 0) {
      const select = labels.map((item) => {
        return item.value;
      });
      objWithLabel = select;
    } else {
      objWithLabel = [];
    }

    if (assignee.length !== 0) {
      objWithAssignee = {
        account_id: assignee[0].value,
        email: assignee[0].email,
        display_name: assignee[0].text,
        locale: assignee[0].locale,
      };
    } else {
      objWithAssignee = {};
    }

    const obj = {
      project: objWithProject,
      issue_type: objWithIssueType,
      components: objWithComponents,
      priority: objWithPriority,
      labels: objWithLabel,
      assignee: objWithAssignee,
    };

    this.setState({
      isModalLoading: true,
    }, () => {
      api
        .setJiraIssueWithPolicy(selectedPolicyId, obj)
        .then(() => {
          this.modalAction = translate('modal.title.notice');
          this.modalBody = translate('settings.message.save_issue_policy_jira_success');

          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
            issueStatus: 1,
          });
        })
        .catch((err) => {
          console.log(err);
          const o = err.data.response;
          this.modalAction = translate('modal.title.attention');

          if (!o.error) {
            this.modalBody = translate('modal.error.unknow_error');
          }

          if (o.error === '422-366') {
            this.modalBody = o.error_description;
          }

          if (o.error === '422-091') {
            this.modalBody = translate('modal.error.error_422_091_param');
          }

          if (o.error === '422-211') {
            this.modalBody = translate('modal.error.error_422_211_value');
          }

          this.setState({
            isModalLoading: false,
            isModalErrorLoading: true,
          });
        });
    });
  }

  loadProjectList = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraProjectList();
      });
    }
  };

  loadIssueType = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraIssueType();
      });
    }
  };

  loadComponents = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraComponents();
      });
    }
  };

  loadPriority = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraPriority();
      });
    }
  };

  loadLabels = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraLabel();
      });
    }
  };

  loadAssignee = () => {
    const { isBoxLoading } = this.state;
    if (!isBoxLoading) {
      this.setState({
        isSetLoading: true,
        isBoxLoading: true,
        isGlobalErrorLoading: false,
        errorMsg: '',
      }, () => {
        this.getJiraAssignee();
      });
    }
  };

  issueValidation() {
    const { translate } = this.props;
    const {
      selectedProject,
      selectedIssueType,
    } = this.state;

    if (selectedProject === '') {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('my_page.project_required');

      this.setState({
        isOpenAlertModal: true,
        isErrorProject: true,
      });
      return false;
    }

    if (selectedIssueType === '') {
      this.modalAction = translate('modal.title.attention');
      this.modalBody = translate('my_page.issue_type_required');

      this.setState({
        isOpenAlertModal: true,
        isErrorIssueType: true,
      });
      return false;
    }
    return true;
  }

  closeModal() {
    const { issueStatus } = this.state;
    const { closeModal, completeCallback } = this.props;

    if (issueStatus === 0) {
      return closeModal();
    }
    completeCallback();
  }

  closeJIraModal() {
    this.setState({
      isOpenJiraModal: false,
      isOpenAlertModal: false,
    });
  }

  render() {
    const {
      isOpenMCI,
      isOpenJiraModal,
      isLoading,
      isModalLoading,
      isOpenAlertModal,
      selectedProject,
      selectedIssueType,
      selectedAssignee,
      selectedComponents,
      selectedLabels,
      selectedPriority,
      issueTypeList,
      projectList,
      componentList,
      priorityList,
      labelList,
      assigneeList,
      isGlobalErrorLoading,
      isModalErrorLoading,
      errorMsg,
      isErrorProject,
      isErrorIssueType,
      isErrorAssignee,
      isErrorComponents,
      isErrorLabels,
      isErrorPriority,
    } = this.state;

    const { translate } = this.props;

    return (
      <Modal
        open={isOpenMCI}
        onClose={this.closeModal}
        className="create_jira_issue"
      >
        <div className="setting_popup_wrap">
          <div className="setting_popup default_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">
                <img className="jira_list" src={JiraLogo} style={{ width: '22px' }} alt="" />
                {translate('settings.list.create_jira_issue')}
                {isGlobalErrorLoading ? <span className="error">{errorMsg}</span> : null}
              </h2>
              <div className="setting_popup_inner_header" style={{ marginTop: '5px' }}>
                {translate('settings.message.save_issue_policy_guide')}
              </div>
              <a
                className="popup_close_button"
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <Scrollbars
              style={{
                height: '490px',
                overflow: 'hidden',
                position: 'relative',
              }}
              renderTrackHorizontal={() => {
                return <div />;
              }}
              renderThumbHorizontal={() => {
                return <div />;
              }}
            >
              <div className="setting_popup_contnets">
                <div className="setting_popup_content_wrap">
                  <Form
                    loading={isLoading}
                  >
                    <Form.Field required>
                      <label>{translate('settings.list.select_project')}</label>
                      <Form.Dropdown
                        placeholder={translate('my_page.select_default_project')}
                        search
                        selection
                        value={selectedProject}
                        options={projectList}
                        onFocus={this.loadProjectList}
                        onChange={this.handleSelectChange}
                        noResultsMessage={translate('modal.message.no_results_found')}
                        error={isErrorProject}
                      />
                    </Form.Field>
                    <Form.Field required>
                      <label>{translate('settings.list.select_issue_type')}</label>
                      <Form.Dropdown
                        placeholder={translate('my_page.select_default_issue_type')}
                        search
                        selection
                        value={selectedIssueType}
                        options={issueTypeList}
                        onFocus={this.loadIssueType}
                        onChange={this.handleIssueSelectChange}
                        disabled={selectedProject === ''}
                        noResultsMessage={translate('modal.message.no_results_found')}
                        error={isErrorIssueType}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('settings.list.select_component')}</label>
                      <Form.Dropdown
                        placeholder={translate('settings.list.select_component_placeholder')}
                        search
                        multiple
                        selection
                        value={selectedComponents}
                        options={componentList}
                        onFocus={this.loadComponents}
                        onChange={this.handleComponentChange}
                        disabled={selectedProject === ''}
                        noResultsMessage={translate('modal.message.no_results_found')}
                        error={isErrorComponents}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('settings.list.select_priority')}</label>
                      <Form.Dropdown
                        placeholder={translate('settings.list.select_priority_placeholder')}
                        search
                        selection
                        value={selectedPriority}
                        options={priorityList}
                        onFocus={this.loadPriority}
                        onChange={this.handlePriorityChange}
                        noResultsMessage={translate('modal.message.no_results_found')}
                        error={isErrorPriority}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('settings.list.select_labels')}</label>
                      <Form.Dropdown
                        placeholder={translate('settings.list.select_labels_placeholder')}
                        search
                        multiple
                        selection
                        value={selectedLabels}
                        options={labelList}
                        onFocus={this.loadLabels}
                        onChange={this.handleLabelChange}
                        noResultsMessage={translate('modal.message.no_results_found')}
                        error={isErrorLabels}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>{translate('settings.list.select_assignee')}</label>
                      <Form.Dropdown
                        placeholder={translate('settings.list.select_assignee_placeholder')}
                        search
                        selection
                        value={selectedAssignee}
                        options={assigneeList}
                        onFocus={this.loadAssignee}
                        onChange={this.handleAssigneeChange}
                        noResultsMessage={translate('modal.message.no_results_found')}
                        disabled={projectList.length === 0}
                        error={isErrorAssignee}
                      />
                    </Form.Field>
                  </Form>
                </div>
              </div>
            </Scrollbars>
            <div className="setting_popup_button_wrap">
              <a
                className="button cencel_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                {translate('modal.button.cancel')}
              </a>
              <a
                className="button save_button"
                style={{ cursor: 'pointer' }}
                onClick={this.onSubmit}
                onKeyUp={this.onSubmit}
              >
                {translate('settings.list.create_issue')}
              </a>
            </div>
          </div>
        </div>
        <Modal open={isOpenAlertModal} onClose={this.closeJIraModal}>
          <div className="modal_popup_wrap confirm_wrap">
            <div className="modal_popup_box confirm_box">
              <div className="modal_popup confirm">
                <h2 className="title">{this.modalAction}</h2>
                <p className="text">{this.modalBody}</p>
                <div className="button_wrap">
                  <a className="center_button" onClick={this.closeJIraModal} onKeyUp={this.closeJIraModal}>
                    {translate('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          open={isOpenJiraModal}
        >
          {
            isModalLoading ? <ClarLoader />
              : (
                <div className="modal_popup_wrap confirm_wrap">
                  <div className="modal_popup_box confirm_box">
                    <div className="modal_popup confirm">
                      <h2 className="title">{this.modalAction}</h2>
                      <p className="text">{this.modalBody}</p>
                      {
                        isModalErrorLoading
                        && (
                          <p className="small_text">
                            {errorMsg}
                          </p>
                        )
                      }
                      {
                        isModalErrorLoading ? (
                          <div className="button_wrap">
                            <a
                              className="center_button"
                              onClick={this.closeModal}
                              onKeyUp={this.closeModal}
                            >
                              {translate('modal.button.ok')}
                            </a>
                          </div>
                        ) : (
                          <div className="button_wrap">
                            <a
                              className="left_button"
                              onClick={this.closeJIraModal}
                              onKeyUp={this.closeJIraModal}
                            >
                              {translate('modal.button.no')}
                            </a>
                            <a
                              className="right_button"
                              onClick={this.setJiraIssueWithPolicy}
                              onKeyUp={this.setJiraIssueWithPolicy}
                            >
                              {translate('modal.button.yes')}
                            </a>
                          </div>
                        )
                      }
                    </div>
                  </div>
                </div>
              )
          }
        </Modal>
      </Modal>
    );
  }
}
export default withTranslation()(inject('state')(observer(CreateJiraIssueModal)));
